import api from './api';

export const getContacts = () => api.get('/connections');
export const getPending = () => api.get('/connections/pending');
export const sendRequest = (recipientId) => api.post('/connections', { recipientId });
export const respondToRequest = (connectionId, status) =>
  api.patch(`/connections/${connectionId}`, { status });
export const removeContact = (connectionId) => api.delete(`/connections/${connectionId}`);
